module.exports = __webpack_public_path__ + "img/Katarina_acc_10.55113eb2.jpg";